import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_PermissionGroup } from './ModuleFE_PermissionGroup.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { TS_Icons } from '@nu-art/ts-styles';
const Props_DropDown = {
    module: ModuleFE_PermissionGroup,
    modules: [ModuleFE_PermissionGroup],
    mapper: item => [item.label],
    placeholder: 'Choose a PermissionGroup',
    renderer: item => _jsx(_Fragment, { children: item.label })
};
export const DropDown_PermissionGroup = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_PermissionGroup,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(TS_Icons.x.component, { onClick: onDelete, className: 'ts-icon__small' }), item.label] });
    },
    uiSelector: DropDown_PermissionGroup.selectable,
});
export const MultiSelect_PermissionGroup = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map